var ProductStatus = /* @__PURE__ */ ((ProductStatus2) => {
  ProductStatus2["AVAILABLE"] = "Available";
  ProductStatus2["NOT_FOR_SALE"] = "Not-for-sale";
  ProductStatus2["OUT_OF_STOCK"] = "Out-of-stock";
  ProductStatus2["AVAILABLE_ONE_LEFT"] = "Available-oneleft";
  ProductStatus2["AVAILABLE_TWO_LEFT"] = "Available-twoleft";
  ProductStatus2["AVAILABLE_FEW_LEFT"] = "Available-fewleft";
  return ProductStatus2;
})(ProductStatus || {});
var ProductCategory = /* @__PURE__ */ ((ProductCategory2) => {
  ProductCategory2["OPTICS"] = "OPTICS";
  ProductCategory2["SUN"] = "SUN";
  ProductCategory2["CONTACT_LENSES"] = "CONTACT LENSES";
  ProductCategory2["EYEWEAR"] = "EYEWEAR";
  ProductCategory2["ACCESSORIES"] = "ACCESSORIES";
  return ProductCategory2;
})(ProductCategory || {});
export {
  ProductCategory,
  ProductStatus
};
//# sourceMappingURL=products.js.map
